<template>
  <v-app>
    <Drawer v-if="isLoggedIn" />

    <v-main>
      <router-view :key="$route.fullPath"></router-view>
    </v-main>

    <Alerts />
  </v-app>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import Drawer from "./components/Layout/Drawer";
import Alerts from "./components/Alerts/Alert";

export default {
  name: "App",

  data() {
    return {};
  },

  components: {
    Drawer,
    Alerts,
  },

  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
  },
};
</script>

<style lang="scss">
  .theme--light.v-application {
    background: #D7DADD;
    a {
      text-decoration: none;
    }
  }
  .v-card__title {
    padding: 8px 16px !important;
    .v-btn { margin: 0 !important; margin-left: 6px !important; }
  }
  .v-card__text {
    padding-bottom: 0 !important;
    .display-1.accent--text { margin-bottom: 0 !important; }
  }
</style>
